export const STALE_TIME = 600000;
